

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "@/components/Config/DataTable.vue"

import User from "@/types/user"
import apiformattingRuleSettings from "@/services/api_FormattingRuleSettings"
import { FormattingRuleSetting } from "@/types/insights/formattingRuleSetting"
import { state } from "@/store/setup"

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader
	}
})
export default class FormattingRuleSetup extends Vue {
	$refs!: {
		dataTable: DataTable
	}

	private loading: boolean = false;
	private formattingRuleSettings: FormattingRuleSetting[] = [];

	public async mounted () {
		await this.loadformattingRuleSettings()
	}

	private get columns (): any[] {
		return [
			{
				key: "title",
				label: "Title",
				sortable: true,
				errors: (item: any) => (item.title !== "") ? null : "Please enter a title."
			},
			{
				key: "dataType",
				label: "Data Type",
				sortable: false,
				dataType: "list",
				options: state.fieldTypes,
				errors: (item: any) => (item.dataType !== undefined && item.dataType !== null) ? null : "Please select a datatype."
			},
			{
				key: "formattingRules",
				label: "Formatting Rules",
				sortable: false,
				dataType: "formattingRules",
				inTable: false,
				errors: (item: any) => (item.formattingRules && item.formattingRules.length > 0) ? null : "Please add at least one formatting rule."
			}
		]
	}

	private async loadformattingRuleSettings () {
		this.loading = true
		this.formattingRuleSettings = await apiformattingRuleSettings.formattingRuleSettingsList()
		this.loading = false
	}

	private createformattingRuleSettings () {
		return { id: null, title: "", default: false }
	}

	private async saveformattingRuleSettings (formattingRuleSettings: FormattingRuleSetting) {
		formattingRuleSettings.id = await apiformattingRuleSettings.formattingRuleSettingsSave(formattingRuleSettings)
		this.loadformattingRuleSettings()
	}

	private async deleteformattingRuleSetting (formattingRuleSettings: FormattingRuleSetting) {
		await apiformattingRuleSettings.formattingRuleSettingsDelete(formattingRuleSettings)
		this.loadformattingRuleSettings()
	}
}
